<template>
  <d2-container>
    <el-form :model="form" :rules="rules" ref="form" label-width="170px">
      <el-form-item
        label="封面图"
        required
        :rules="{ required: true, message: '请上传封面图', trigger: 'change' }"
        prop="cover2"
      >
        <uploadImg v-model="form.cover" :imgSize="1" :text="['图片大小500kb以内', '图片格式png/jpg/gif']"></uploadImg>
      </el-form-item>
      <el-form-item label="标题" prop="title">
        <el-input v-model="form.title" placeholder="请输入标题"></el-input>
      </el-form-item>
      <el-form-item label="介绍" prop="introduce">
        <el-input type="textarea" :rows="2" placeholder="请输入介绍内容" v-model="form.introduce"></el-input>
      </el-form-item>
    </el-form>
    <div class="footer" v-if="!editorialJudgment">
      <el-button @click="cancel('form')">取 消</el-button>
      <el-button type="primary" @click="getCreate('form')">确 定</el-button>
    </div>
    <div class="footer" v-if="editorialJudgment">
      <el-button @click="cancel('form')">取 消</el-button>
      <el-button type="primary" @click="getModify('form')">确 定</el-button>
    </div>
  </d2-container>
</template>

<script>
import { mapGetters } from 'vuex'
import uploadImg from '@/components/uploadImage/index.vue'
import {
  addFormDetails,
  updateFormDetailList,
  getFormDetailList
} from '@/api/demo/loveCounselor/index'
export default {
  components: {
    uploadImg
  },
  name: 'discountAdd',
  data () {
    return {
      radio: '1',
      tableKey: 0,
      listQuery: {
        currentPage: 1,
        pageSize: 20,
        keyword: ''
      },
      form: {
        cover: '', // 封面图
        cover2: [],
        title: null, // 标题
        introduce: null // 介绍
      },
      rules: {
        title: [
          {
            required: true,
            message: '请输入标题',
            trigger: 'blur'
          },
          {
            min: 1,
            max: 20,
            message: '长度在 1 到 20 个字符',
            trigger: 'blur'
          }
        ]
      },
      editorialJudgment: false // 判断新增或者编辑
    }
  },
  computed: {
    ...mapGetters(['elements'])
  },
  created () {
    let that = this
    this.getId = this.$route.query.id
    if (this.getId != undefined) {
      that.editorialJudgment = true
      that.getListArr()
    } else if (this.getId == undefined) {
      that.editorialJudgment = false
    }
  },
  watch: {
    $route (to, from) {
      // this.getList();
    }
  },
  mounted () {},
  methods: {
    getListArr () {
      let that = this
      getFormDetailList(that.getId).then(res => {
        let key = 'cover2'
        var value = []
        res[key] = value
        if (res.cover != '') {
          res.cover2 = res.cover.split()
        }
        that.form = res
      })
    },
    // 开始时间
    dataSearch (e) {
      this.form.startTime = e
      console.log('e', this.form.startTime)
    },
    // 结束时间
    dataEnd (e) {
      this.form.endTime = e
      console.log('e', this.form.endTime)
    },
    // 新增
    getCreate (formName) {
      let that = this
      this.$refs[formName].validate(valid => {
        if (valid) {
          addFormDetails(this.form).then(res => {
            that.$notify({
              title: '成功',
              message: '新增成功',
              type: 'success',
              duration: 2000
            })
            that.$router.push('/demo/loveCounselor')
          })
        }
      })
    },
    // 编辑确定
    getModify (formName) {
      let that = this
      this.$refs[formName].validate(valid => {
        if (valid) {
          updateFormDetailList(this.getId, this.form).then(res => {
            that.$notify({
              title: '成功',
              message: '修改成功',
              type: 'success',
              duration: 2000
            })
            that.$router.push('/demo/loveCounselor')
          })
        }
      })
    },
    // 取消
    cancel (formName) {
      this.$router.push('/demo/loveCounselor')
    }
  }
}
</script>
<style scoped>
.footer {
  text-align: center;
  margin-top: 30px;
}
.el-dialog__footer {
  display: flex;
}
</style>
